import { render } from "./product-all.vue?vue&type=template&id=9c079a5c"
import script from "./product-all.vue?vue&type=script&lang=js"
export * from "./product-all.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__